import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ProfileSurveyService } from '../../../service/profile-survey/profile-survey.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteProfileSurveyComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-profile-survey',
  templateUrl: './autocomplete-profile-survey.component.html',
  styleUrls: ['./autocomplete-profile-survey.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class AutocompleteProfileSurveyComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() profileSurveyId: number;
    @Input() profileSurveyPosition: string;
    @Input() customerGuideId: any;
    @Output() onMyChange = new EventEmitter();
    @Input() disabled: boolean;
    @Input() readOnly: boolean;
    @Input() activated_profile_survey: boolean;

    @ViewChild('input') textarea;

    public options: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    public sel: any;

    constructor(
        private renderer: Renderer2,
        public profileSurveyService: ProfileSurveyService
    ) {
        this.page = 1;
        this.per_page = 10;
    }

    public ngOnInit() {
        // this.query = undefined;
        // this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
        // if (this.profileSurveyId) {
        //     this.filters.push({key: 'id-lk', value: String(this.profileSurveyId)});
        // }
        // if (this.profileSurveyPosition) {
        //     this.filters.push({key: 'profile-survey_position_id', value: this.profileSurveyPosition});
        // }
        // if (this.customerGuideId) {
        //     this.filters.push({key: 'customer_guide_id-lk', value: String(this.customerGuideId)});
        // }
        // if(this.profileSurveyId)
        //     this.getProfileSurveis(this.query, this.filters);
    }

    public ngOnChanges() {
        this.query = undefined;
        this.filters = [];
        if (this.activated_profile_survey) {
            this.filters.push({key: 'activated-lk', value: '1'});    
        }
        
        if (this.profileSurveyPosition) {
            this.filters.push({key: 'profile-survey_position_id', value: this.profileSurveyPosition});
        }
        if (this.customerGuideId) {
            this.filters.push({key: 'customer_guide_id-lk', value: String(this.customerGuideId)});
            // this.getProfileSurveis(this.query, this.filters);
        }
        if (this.profileSurveyId) {
            this.filters.push({key: 'id-lk', value: String(this.profileSurveyId)});
            this.getProfileSurveis(this.query, this.filters);
        }
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }
    setDisabledState(isDisabled: boolean ) {
        this.disabled = isDisabled;
    }
    // setreadonly (v) {
    //     this.readOnly =v;
    //  };
    setReadOnlyState(isReadOnly: boolean ) {
        this.readOnly = isReadOnly;
    }
    public change($event) {
        console.log(this.sel);
        if(this.sel.id || this.sel ==""){            
            this.onChange(this.sel);
            this.onTouched(this.sel);
            this.onMyChange.emit(this.sel);
        }
    }

    public loadProfileSurveisLazy(event) {
        // this.getProfileSurveis(event.query);
        var str=event.query;
        var res = str.replace(/\s/g, "%");
        this.getProfileSurveis(res);
    }

    getProfileSurveis(query?: string, filters?: any[]) {
        this.profileSurveyService.getProfileSurvey(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.options = response.json().data;
                if (this.profileSurveyId) {
                    this.profileSurveyId = undefined;
                    this.sel = this.options[0];
                    this.filters = [];
                    this.filters.push({key: 'activated-lk', value: '1'});
                    if (this.profileSurveyPosition) {
                        this.filters.push({key: 'profile-survey_position_id', value: this.profileSurveyPosition});
                    }
                    if (this.customerGuideId) {
                        this.filters.push({key: 'customer_guide_id-lk', value: String(this.customerGuideId)});
                    }
                }

                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.options = [];
                this.options.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/profile-surveis/autocomplete-profile-survey/autocomplete-profile-survey.component.ts